import { motion } from "framer-motion";
import { GALLERY } from "@/data/content";
import HammersBackdrop from "@/components/site/HammersBackdrop";

export default function AboutSection() {
  return (
    <section
      id="about"
      className="relative bg-paper-alt py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <HammersBackdrop density="light" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6 relative"
          >
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-[#e7e5df] shadow-xl">
              <img
                src={GALLERY[0].src}
                alt={GALLERY[0].alt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 md:-right-8 bg-[#16a34a] text-white rounded-3xl p-6 md:p-8 shadow-2xl max-w-[260px] hidden sm:block">
              <div className="font-display font-black text-5xl leading-none">
                10+
              </div>
              <div className="text-sm font-semibold mt-2 opacity-95">
                years of dependable service across Tampa Bay
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-6"
          >
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
              Our Story
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-3 tracking-tight">
              Built on craftsmanship.{" "}
              <span className="text-[#57534e]">Run on trust.</span>
            </h2>
            <div className="mt-6 space-y-5 text-[#3c4043] text-base md:text-lg leading-relaxed">
              <p>
                ProCraft Solutions was founded with a simple goal: provide
                dependable, high-quality property services backed by honest
                communication and pride in our work. What started as a passion
                for hands-on craftsmanship has grown into a trusted local
                company serving residential and commercial clients.
              </p>
              <p>
                From day one, we focused on doing things the{" "}
                <span className="font-bold text-[#1c1917]">right way</span> —
                showing up on time, paying attention to details, and delivering
                results that last. As we&rsquo;ve grown, our commitment to
                quality, reliability, and customer satisfaction hasn&rsquo;t
                budged.
              </p>
              <p>
                We believe strong relationships are built through consistent
                service. Our story continues with every property we touch and
                every client who chooses us to care for their home or business.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="rounded-2xl bg-white border border-[#e7e5df] p-5">
                <div className="font-display font-black text-3xl text-[#16a34a]">
                  500+
                </div>
                <div className="text-sm font-semibold text-[#57534e] mt-1">
                  Properties served
                </div>
              </div>
              <div className="rounded-2xl bg-white border border-[#e7e5df] p-5">
                <div className="font-display font-black text-3xl text-[#16a34a]">
                  100%
                </div>
                <div className="text-sm font-semibold text-[#57534e] mt-1">
                  Licensed & Insured
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
